import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import TreatmentsHero from './components/TreatmentsHero';
import TreatmentsGrid from './components/TreatmentsGrid';
import AddOnsSection from './components/AddOnsSection';
import PeptidesSection from './components/PeptidesSection';
import AppDownloadSection from '../../components/feature/AppDownloadSection';

export default function TreatmentsPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          el.classList.add('ring-2', 'ring-gold', 'ring-offset-2');
          setTimeout(() => el.classList.remove('ring-2', 'ring-gold', 'ring-offset-2'), 2000);
        }, 400);
      }
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-sand">
      <Navigation />
      <TreatmentsHero />
      <TreatmentsGrid />
      <AddOnsSection />
      <PeptidesSection />
      <AppDownloadSection />
      <Footer />
    </div>
  );
}
